import React, { useEffect, useState } from "react";
import axiosClient from "../api/axiosClient";
import { useNavigate } from "react-router-dom";

const Posts = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [apiError, setApiError] = useState("");
    const [deletingId, setDeletingId] = useState(null);
    
    const navigate = useNavigate();
    
    useEffect(() => {
        fetchPosts();
    }, []);
    
    const fetchPosts = async () => {
        setLoading(true);
        setApiError("");
        try {
            const res = await axiosClient.get("/posts");
            setPosts(res.data.data || []);
        } catch (err) {
            setApiError("Failed to load posts.");
        } finally {
            setLoading(false);
        }
    };
    
    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this post?")) return;
        setDeletingId(id);
        try {
            await axiosClient.delete(`/posts/${id}`);
            setPosts(posts.filter((post) => post.id !== id));
        } catch (err) {
            alert("Failed to delete post.");
        } finally {
            setDeletingId(null);
        }
    };
    
    const handleEdit = (id) => {
        navigate(`/posts/edit/${id}`);
    };
    
    return (
        <div className="container mt-4" style={{ maxWidth: "1100px" }}>
            <h2 className="mb-4">Posts</h2>
            
            {apiError && <div className="alert alert-danger">{apiError}</div>}
            
            <div className="mb-3 text-end">
                <button
                    className="btn btn-primary"
                    onClick={() => navigate("/posts/create")}
                >
                    + Create New Post
                </button>
            </div>
            
            <div className="table-responsive">
                <table className="table table-striped align-middle">
                    <thead>
                    <tr>
                        <th>Title</th>
                        <th>Slug</th>
                        <th>Author</th>
                        <th>Status</th>
                        <th>Tags</th>
                        <th>Created</th>
                        <th>Image</th>
                        <th style={{ width: 140 }}>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan={8} className="text-center">
                                Loading...
                            </td>
                        </tr>
                    ) : posts.length === 0 ? (
                        <tr>
                            <td colSpan={8} className="text-center">
                                No posts found.
                            </td>
                        </tr>
                    ) : (
                        posts.map((post) => (
                            <tr key={post.id}>
                                <td>{post.title}</td>
                                <td>{post.slug}</td>
                                <td>
                                    {post.user?.name}{" "}
                                    <span className="text-muted">@{post.user?.username}</span>
                                </td>
                                <td>
                    <span className={post.status === "published" ? "badge bg-success" : "badge bg-secondary"}>
                      {post.status}
                    </span>
                                </td>
                                <td>
                                    {post.tags && post.tags.length > 0
                                        ? post.tags.map((tagObj) => (
                                            <span key={tagObj.tag?.id} className="badge bg-info text-dark me-1">
                            {tagObj.tag?.name}
                          </span>
                                        ))
                                        : <span className="text-muted">No tags</span>
                                    }
                                </td>
                                <td>
                                    {post.createdAt
                                        ? new Date(post.createdAt).toLocaleString()
                                        : ""}
                                </td>
                                <td>
                                    {post.featuredImage && (
                                        <img
                                            src={post.featuredImage}
                                            alt={post.title}
                                            style={{ maxWidth: 60, maxHeight: 36, objectFit: "cover" }}
                                        />
                                    )}
                                </td>
                                <td>
                                    <button
                                        className="btn btn-sm btn-outline-primary me-2"
                                        onClick={() => handleEdit(post.id)}
                                    >
                                        Edit
                                    </button>
                                    <button
                                        className="btn btn-sm btn-outline-danger"
                                        onClick={() => handleDelete(post.id)}
                                        disabled={deletingId === post.id}
                                    >
                                        {deletingId === post.id ? "Deleting..." : "Delete"}
                                    </button>
                                </td>
                            </tr>
                        ))
                    )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Posts;
